<template>
  <div>
    <h1 class="h3 mb-3 font-weight-normal text-center">{{titleText}}</h1>
    <form v-if="!feedSelected" class="form-signin" novalidate>
      <user-menu-select-feed v-on:changed="onSelectedProviderChanged" />
      <user-menu-button-bar v-on:executeCancel="onExecuteCancel" />
    </form>
    <user-menu-add-form
      v-if="feedSelected  && newFeed.type == 1"
      okButtonName="Feed ändern"
      :initFeed="this.newFeed"
      :initStep="0"
      :editMode="true"
      :callbackExecuteAction="this.onStartAction"
      v-on:executeCancel="onExecuteCancel"
    />
    <user-menu-add-form
      v-if="feedSelected  && newFeed.type == 2"
      okButtonName="Krypto ändern"
      :initFeed="this.newFeed"
      :initStep="3"
      :editMode="false"
      :callbackExecuteAction="this.onStartAction"
      v-on:executeCancel="onExecuteCancel"
    />
    <provider-gas-price
      v-if="feedSelected  && newFeed.type == 3"
      :initFeed="this.newFeed"
      v-on:executeStop="onExecuteCancel"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";

import UserMenuSelectFeed from "./User.Menu.SelectFeed.vue";
import UserMenuButtonBar from "./User.Menu.ButtonBar.vue";
import UserMenuAddForm from "./User.Menu.AddForm.vue";
import ProviderGasPrice from "./Provider/ProviderGasPrice.vue";

export default {
  name: "User.Menu.Add",
  components: {
    UserMenuSelectFeed,
    UserMenuButtonBar,
    UserMenuAddForm,
    ProviderGasPrice
  },
  data: function() {
    return {
      newFeed: {
        indexCategory: 0,
        indexFeed: 0,
        type: 1,
        url: "",
        name: "",
        category: ""
      },
      feedSelected: false
    };
  },
  computed: {
    titleText() {
      if (!this.feedSelected) return "Anbieter ändern";
      else if (this.newFeed.type == 1) return "Feed ändern";
      else if (this.newFeed.type == 2) return "Kryptowährung ändern";
      else if (this.newFeed.type == 3) return "Spritpreise ändern";
      else return "Anbieter ändern";
    }
  },
  methods: {
    ...mapActions(["editUserFeed"]),
    onStartAction: function(feed) {
      this.editUserFeed(feed).then(() =>
        this.$router.push({
          name: "user",
          params: { category: feed.categoryId }
        })
      );
    },
    onExecuteCancel: function() {
      this.$emit("executeStop");
    },
    onSelectedProviderChanged: function(aFeed) {
      this.feedSelected = true;
      this.newFeed = aFeed;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
</style>
